// extracted by mini-css-extract-plugin
module.exports = {"ring":"Loading_ring__3_1jO","lds-ring":"Loading_lds-ring__1uPz_"};